import { IOption } from '@/types/global.ts'
import systemEventsUtils from '../../systemEvents.utils.ts'
import { ISystemEvent } from '../../systemEvents.types.ts'

const fieldTypeOptions: IOption<ISystemEvent['type']>[] = [
  { title: systemEventsUtils.getTypeText('ALARM_SITUATION_INCIDENT'), value: 'ALARM_SITUATION_INCIDENT' },
  { title: systemEventsUtils.getTypeText('SYSTEM_LOG'), value: 'SYSTEM_LOG' },
  { title: systemEventsUtils.getTypeText('LP_ERROR'), value: 'LP_ERROR' },
  { title: systemEventsUtils.getTypeText('MOVED_TO_MAINTENANCE'), value: 'MOVED_TO_MAINTENANCE' },
]

const systemEventsTypeConstants = { fieldTypeOptions }
export default systemEventsTypeConstants
